import Swiper from 'swiper/bundle'
import 'swiper/css/bundle'

document.querySelectorAll('.help-slider, .help-slider-tablet').forEach(($el) => {
    new Swiper($el, {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: true,
        navigation: {
            prevEl: $el.closest('.swiper-container').querySelector('.prev-slide'),
            nextEl: $el.closest('.swiper-container').querySelector('.next-slide'),
        },
        on: {
            init() {
                updateIndex(this)
                setTimeout(() => {
                    this.el.dispatchEvent(new CustomEvent('shape:rebuild', { bubbles: true }))
                }, 1000)
            },
            slideChange() {
                updateIndex(this)
            },
        },
    })

    function updateIndex(swiper) {
        swiper.el.style.setProperty('--current-index', swiper.activeIndex)
    }
})

document.querySelectorAll('.social-slider').forEach(($el) => {
    new Swiper($el, {
        slidesPerView: 1.15,
        spaceBetween: 24,
        loop: true,
        breakpoints: {
            768: {
                slidesPerView: 2.5,
                spaceBetween: 24,
            },
            1280: {
                slidesPerView: 'auto',
                spaceBetween: 72,
            },
        },
        navigation: {
            prevEl: $el.closest('.swiper-container').querySelector('.prev-slide'),
            nextEl: $el.closest('.swiper-container').querySelector('.next-slide'),
        },
    })
})

document.querySelectorAll('.news-events-slider').forEach($el => {
    new Swiper($el, {
        slidesPerView: 1.15,
        spaceBetween: 16,
        loop: true,
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 24,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 24,
            },
            1280: {
                slidesPerView: 4,
                spaceBetween: 24 ,
            },
        },
        navigation: {
            prevEl: $el.closest('.swiper-container').querySelector('.prev-slide'),
            nextEl: $el.closest('.swiper-container').querySelector('.next-slide'),
        },
        on: {
            init() {
                updateIndex(this)
            },
            slideChange() {
                updateIndex(this)
            },
        },
    })

    function updateIndex(swiper) {
        swiper.el.style.setProperty('--current-index', swiper.activeIndex)
    }
})
